export default {
  getCreatePayrollById: (state) => (id) => {
    const payroll = state.getAllCreatePayroll.find(
      (a) => a.createPayrollId === id
    );
    console.log(`Payroll with ID ${id}:`, payroll); // Logging the payroll object
    return payroll;
  },

  getCreatePayrollByIdNotClosed: (state) => (id) =>
    state.getAllCreatePayroll.find(
      (a) => a.createPayrollId === id && !a.isClosed
    ),

  getUploadedLogHoursByEmpCode: (state) => (empCode) =>
    state.uploadedLogHours.find((a) => a.code === empCode),

  getCreatePayrollByPayrollType: (state) => (id) =>
    state.getAllCreatePayroll.find(
      (a) => a.createPayrollTypeId === id && a.isClosed === false
    ),

  getAllActiveCreatePayrollId: (state) => () =>
    state.getAllCreatePayroll.filter((a) => !a.isClosed),

  getLogHoursByUserId: (state) => (userId) =>
    state.getAllLogHours.find((a) => a.userId === userId),

  getLogHoursById: (state) => (id) =>
    state.getAllLogHours.find((a) => a.id === id),

  getOvertimeByUserId: (state) => (userId) =>
    state.getAllOvertime.filter((a) => a.userId === userId),

  getOvertimeById: (state) => (id) =>
    state.getAllOvertime.find((a) => a.id === id),

  getEarningsByUserId: (state) => (userId) =>
    state.getAllEarnings.filter((a) => a.userId === userId),

  getEarningsById: (state) => (id) =>
    state.getAllEarnings.find((a) => a.id === id),

  getEarningsByPeriodSemi: (state) => (periodId) =>
    state.getAllEarnings.filter(
      (a) => a.periodId === periodId || a.periodId === 5
    ),

  getEarningsByPeriodWeek: (state) => (periodId) =>
    state.getAllEarnings.filter(
      (a) => a.periodId === periodId || a.periodId === 11
    ),

  getDeductionsByUserId: (state) => (id) =>
    state.getAllDeductions.filter((a) => a.userId === id),

  getDeductionsById: (state) => (id) =>
    state.getAllDeductions.find((a) => a.id === id),

  getDeductionsByPeriodSemi: (state) => (periodId) =>
    state.getAllDeductions.filter(
      (a) => a.periodId === periodId || a.periodId === 5
    ),

  getDeductionsByPeriodWeek: (state) => (periodId) =>
    state.getAllDeductions.filter(
      (a) => a.periodId === periodId || a.periodId === 11
    ),

  getLoansByUserId: (state) => (id) =>
    state.getAllLoans.filter((a) => a.userId === id),

  getLoansById: (state) => (id) => state.getAllLoans.find((a) => a.id === id),

  getLoansByPeriodSemi: (state) => (periodId) =>
    state.getAllLoans.filter(
      (a) => a.periodId === periodId || a.periodId === 5
    ),

  getLoansByPeriodWeek: (state) => (periodId) =>
    state.getAllLoans.filter(
      (a) => a.periodId === periodId || a.periodId === 11
    ),
};
